import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	labelWrapperStyle: {
		'& .MuiFormLabel-root': {
			color: 'inherit'
		}
	},
	valueWrapperStyle: {
		display: 'flex',
		justifyContent: 'flex-end'
	},
	wrapperStyle: {
		// paddingTop: theme.spacing(2),
		paddingBottom: props => (props.noGutter ? 0 : theme.spacing(2)),
		display: 'flex',
		flex: 1,
		alignItems: 'center',
		flexDirection: 'row',
		justifyContent: 'space-between'
	}
}));

const LabelValueComponent = ({ label, value, noGutter, labelClasses = '', valueClasses = '' }) => {
	const classes = useStyles({ noGutter });
	return (
		<div className={classes.wrapperStyle}>
			<div className={`${classes.labelWrapperStyle} ${labelClasses}`}>{label}</div>
			<div className={`${classes.valueWrapperStyle} ${valueClasses}`}>{value}</div>
		</div>
	);
};

LabelValueComponent.propTypes = {
	label: PropTypes.element,
	value: PropTypes.element,
	noGutter: PropTypes.bool,
	labelClasses: PropTypes.string,
	valueClasses: PropTypes.string
};

export default LabelValueComponent;
